import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import laravel from '../img/laravel.png';
import "./About.css";

function Laravel() {
  // Script pour le burger menu
  useEffect(() => {
    const burger = document.getElementById("burger");
    const navLinks = document.getElementById("nav-links");

    const toggleMenu = () => {
      navLinks.classList.toggle("active");
      burger.classList.toggle("toggle");
    };

    burger.addEventListener("click", toggleMenu);

    return () => {
      burger.removeEventListener("click", toggleMenu);
    };
  }, []);

  return (
    <>
      <Header />

      <article className="competence-page">
        <h1>Laravel</h1>

        <div className="competence-intro">
          <img src={laravel} alt="Laravel" loading="lazy" />

          <p>
            <strong>Laravel</strong> est un framework PHP moderne permettant
            de développer des applications web robustes, structurées et
            évolutives.
          </p>

          <p>
            Il propose de nombreux outils pour simplifier le développement,
            notamment la gestion des routes, des bases de données, de
            l'authentification, des formulaires et des API.
          </p>
        </div>

        <section className="competence-details">
          <h2>Applications pratiques</h2>

          <ul>
            <li>Développement d'applications web dynamiques</li>
            <li>Création d'API REST</li>
            <li>Gestion et manipulation de bases de données avec Eloquent</li>
            <li>Gestion des utilisateurs et de l'authentification</li>
            <li>Création de systèmes d'administration</li>
            <li>Développement d'applications structurées et évolutives</li>
          </ul>

          <h2>Ressources pour débutants</h2>

          <ul>
            <li>
              <a
                href="https://laravel.com/docs"
                target="_blank"
                rel="noopener noreferrer"
              >
                Documentation officielle Laravel
              </a>
            </li>

            <li>
              <a
                href="https://laracasts.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Laracasts
              </a>
            </li>

            <li>
              <a
                href="https://laravel-news.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Laravel News
              </a>
            </li>
          </ul>
        </section>

        <Link to="/about" className="btn-back">
          ← Retour aux compétences
        </Link>
      </article>

      <Footer />
    </>
  );
}

export default Laravel;